(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('TvDialogController', TvDialogController);

    TvDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Tv'];

    function TvDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Tv) {
        var vm = this;

        vm.tv = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tv.id !== null) {
                Tv.update(vm.tv, onSaveSuccess, onSaveError);
            } else {
                Tv.save(vm.tv, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:tvUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
